import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useRef, useState, useEffect } from "react";
import { isObjectType, isInterfaceType, isInputObjectType } from "graphql";
import { ComboboxOptions, ComboboxOption, ComboboxInput, Combobox } from "@headlessui/react";
import { debounce, formatShortcutForOS, KEY_MAP, typeCategory, MagnifyingGlassIcon, KeycapHint } from "@graphiql/react";
import { useDocExplorer, useDocExplorerActions } from "../context.js";
import { useSearchResults } from "./search.js";
import { renderType } from "./utils.js";
/* empty css               */
const SearchRow = () => {
  const $ = c(39);
  const explorerNavStack = useDocExplorer();
  const {
    push
  } = useDocExplorerActions();
  const inputRef = useRef(null);
  const getSearchResults = useSearchResults();
  const [searchValue, setSearchValue] = useState("");
  let t0;
  if ($[0] !== getSearchResults || $[1] !== searchValue) {
    t0 = () => getSearchResults(searchValue);
    $[0] = getSearchResults;
    $[1] = searchValue;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const [results, setResults] = useState(t0);
  let t1;
  if ($[3] !== getSearchResults) {
    t1 = debounce(200, (search) => {
      setResults(getSearchResults(search));
    });
    $[3] = getSearchResults;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const debouncedGetSearchResults = t1;
  const [isFocused, setIsFocused] = useState(false);
  let t2;
  let t3;
  if ($[5] !== debouncedGetSearchResults || $[6] !== searchValue) {
    t2 = () => {
      debouncedGetSearchResults(searchValue);
    };
    t3 = [debouncedGetSearchResults, searchValue];
    $[5] = debouncedGetSearchResults;
    $[6] = searchValue;
    $[7] = t2;
    $[8] = t3;
  } else {
    t2 = $[7];
    t3 = $[8];
  }
  useEffect(t2, t3);
  let navItem;
  let onSelect;
  let t4;
  if ($[9] !== explorerNavStack || $[10] !== push) {
    navItem = explorerNavStack.at(-1);
    let t52;
    if ($[14] !== push) {
      t52 = (def) => {
        if (!def) {
          return;
        }
        push("field" in def ? {
          name: def.field.name,
          def: def.field
        } : {
          name: def.type.name,
          def: def.type
        });
      };
      $[14] = push;
      $[15] = t52;
    } else {
      t52 = $[15];
    }
    onSelect = t52;
    t4 = explorerNavStack.length === 1 || isObjectType(navItem.def) || isInterfaceType(navItem.def) || isInputObjectType(navItem.def);
    $[9] = explorerNavStack;
    $[10] = push;
    $[11] = navItem;
    $[12] = onSelect;
    $[13] = t4;
  } else {
    navItem = $[11];
    onSelect = $[12];
    t4 = $[13];
  }
  const shouldShow = t4;
  if (!shouldShow) {
    return null;
  }
  let t5;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = formatShortcutForOS(KEY_MAP.searchInDocs.key).split("-");
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  const shortcutKeys = t5;
  const t6 = `Search ${navItem.name}...`;
  let t7;
  let t8;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      inputRef.current.focus();
    };
    t8 = /* @__PURE__ */ jsx(MagnifyingGlassIcon, { "aria-hidden": "true" });
    $[17] = t7;
    $[18] = t8;
  } else {
    t7 = $[17];
    t8 = $[18];
  }
  let t10;
  let t11;
  let t9;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = (event) => setSearchValue(event.target.value);
    t10 = () => setIsFocused(true);
    t11 = () => setIsFocused(false);
    $[19] = t10;
    $[20] = t11;
    $[21] = t9;
  } else {
    t10 = $[19];
    t11 = $[20];
    t9 = $[21];
  }
  let t12;
  if ($[22] !== searchValue) {
    t12 = /* @__PURE__ */ jsx(ComboboxInput, { autoComplete: "off", onChange: t9, onFocus: t10, onBlur: t11, placeholder: "Search schema", ref: inputRef, value: searchValue, "data-cy": "doc-explorer-input" });
    $[22] = searchValue;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== isFocused || $[25] !== searchValue || $[26] !== shortcutKeys) {
    t13 = !isFocused && !searchValue && /* @__PURE__ */ jsx(KeycapHint, { keys: shortcutKeys, ariaLabel: "Search docs shortcut" });
    $[24] = isFocused;
    $[25] = searchValue;
    $[26] = shortcutKeys;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t12 || $[29] !== t13) {
    t14 = /* @__PURE__ */ jsxs("div", { className: "graphiql-doc-explorer-search-row-input", onClick: t7, children: [
      t8,
      t12,
      t13
    ] });
    $[28] = t12;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== isFocused || $[32] !== results) {
    t15 = isFocused && /* @__PURE__ */ jsxs(ComboboxOptions, { className: "graphiql-doc-explorer-search-row-listbox", "data-cy": "doc-explorer-list", children: [
      results.within.length + results.types.length + results.fields.length === 0 ? /* @__PURE__ */ jsx("div", { className: "graphiql-doc-explorer-search-empty", children: "No results found" }) : results.within.map(_temp),
      results.within.length > 0 && results.types.length + results.fields.length > 0 ? /* @__PURE__ */ jsx("div", { className: "graphiql-doc-explorer-search-divider", children: "Other results" }) : null,
      results.types.map(_temp2),
      results.fields.map(_temp3)
    ] });
    $[31] = isFocused;
    $[32] = results;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== onSelect || $[35] !== t14 || $[36] !== t15 || $[37] !== t6) {
    t16 = /* @__PURE__ */ jsx("div", { className: "graphiql-doc-explorer-search-row-wrapper", children: /* @__PURE__ */ jsxs(Combobox, { as: "div", className: "graphiql-doc-explorer-search-row", onChange: onSelect, "aria-label": t6, children: [
      t14,
      t15
    ] }) });
    $[34] = onSelect;
    $[35] = t14;
    $[36] = t15;
    $[37] = t6;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  return t16;
};
const SearchType = (t0) => {
  const $ = c(5);
  const {
    type
  } = t0;
  let t1;
  if ($[0] !== type) {
    t1 = typeCategory(type);
    $[0] = type;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1 || $[3] !== type.name) {
    t2 = /* @__PURE__ */ jsx("span", { className: "graphiql-doc-explorer-search-type", "data-type-kind": t1, children: type.name });
    $[2] = t1;
    $[3] = type.name;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
const SearchField = (t0) => {
  const $ = c(7);
  const {
    field,
    argument
  } = t0;
  let t1;
  if ($[0] !== field.name) {
    t1 = /* @__PURE__ */ jsx("span", { className: "graphiql-doc-explorer-search-field", children: field.name });
    $[0] = field.name;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== argument) {
    t2 = argument ? /* @__PURE__ */ jsxs(Fragment, { children: [
      "(",
      /* @__PURE__ */ jsx("span", { className: "graphiql-doc-explorer-search-argument", children: argument.name }),
      ":",
      " ",
      renderType(argument.type, _temp4),
      ")"
    ] }) : null;
    $[2] = argument;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = /* @__PURE__ */ jsxs(Fragment, { children: [
      t1,
      t2
    ] });
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
function _temp(result, i) {
  return /* @__PURE__ */ jsx(ComboboxOption, { value: result, "data-cy": "doc-explorer-option", children: /* @__PURE__ */ jsx(SearchField, { field: result.field, argument: result.argument }) }, `within-${i}`);
}
function _temp2(result_0, i_0) {
  return /* @__PURE__ */ jsx(ComboboxOption, { value: result_0, "data-cy": "doc-explorer-option", children: /* @__PURE__ */ jsx(SearchType, { type: result_0.type }) }, `type-${i_0}`);
}
function _temp3(result_1, i_1) {
  return /* @__PURE__ */ jsxs(ComboboxOption, { value: result_1, "data-cy": "doc-explorer-option", children: [
    /* @__PURE__ */ jsx(SearchType, { type: result_1.type }),
    ".",
    /* @__PURE__ */ jsx(SearchField, { field: result_1.field, argument: result_1.argument })
  ] }, `field-${i_1}`);
}
function _temp4(namedType) {
  return /* @__PURE__ */ jsx(SearchType, { type: namedType });
}
export {
  SearchRow
};
//# sourceMappingURL=search-row.js.map
